import { Button, Space, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

export function settingsTableColumns<T extends { id: number; name: string; client_manager_id?: number | null; }>(
    onEdit: (item: T) => void,
    onDelete: (item: T) => void
): ColumnsType<T> {
    return [
        {
            title: 'Nome da categoria',
            dataIndex: 'name',
            key: 'name',
            onFilter: (value, record) =>
                record.name.toLowerCase().includes((value as string).toLowerCase()),
            filterSearch: true,
        },
        {
            title: 'Tipo',
            dataIndex: 'client_manager_id',
            key: 'client_manager_id',
            render: (value) =>
                value === null ? (
                    <Tag>Padrão</Tag>
                ) : (
                    <Tag color="blue">Customizada</Tag>
                ),
        },
        {
            title: '',
            key: 'actions',
            width: 120,
            align: 'center',
            render: (_, item) => (
                item.client_manager_id === null ? null : (
                    <Space>
                        <Button type="text" icon={<EditOutlined />} onClick={() => onEdit(item)} />
                        <Button type="text" icon={<DeleteOutlined />} danger onClick={() => onDelete(item)} />
                    </Space>
                )
            ),
        },
    ];
}